// extracted by mini-css-extract-plugin
export var productImage = "_l2-1";
export var viewLink = "_l2-2";
export var wishlistItem = "_l2-0";